import TestView from "./view";
import Tests from "./tests";
import Tester from "./tester";
export default function TestScreen(element) {
  const view = TestView(element);
  const tests = view.getTestElements().map(createTest);
  async function show() {
    view.setButtonEnabled(false);
    view.setButtonText("Starten");
    const res = await Promise.all(tests);
    const allOk = res.filter(r => r).length == res.length;
    if (allOk) return;
    view.setButtonText("Trotz Fehler starten");
    view.setButtonEnabled(true);
    return view.promisedButtonClick();
  }
  return Object.assign(view, {
    show
  });
}
function createTest(element) {
  const func = Tests[element.name];
  return Tester({
    element,
    func
  });
}